import { z } from 'zod';

export const jobChangeProcessStatusNextStepSchema = z.object({
  status: z.string().min(1),
  date: z.date().optional(),
});

export type JobChangeProcessStatusNextStepSchema = z.infer<
  typeof jobChangeProcessStatusNextStepSchema
>;
